import {
  Film,
  Gift,
  Handshake,
  type LucideIcon,
  Tent,
  Ticket,
  RollerCoaster,
  BadgePercent,
} from "lucide-react";
import { TAG_COLORS } from "@/features/shop";

type BaseTagProps = {
  icon: LucideIcon
  label: string
  backgroundColor: string
  textColor: string
  minimized?: boolean
};

type TagProps = { minimized?: boolean };

type DiscountTagProps = {
  discount: number | string
  minimized?: boolean
};

const BaseTag = ({
  icon: Icon,
  label,
  backgroundColor,
  textColor,
  minimized = false,
}: BaseTagProps) => {
  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded ${backgroundColor} ${textColor} ${
        minimized ? "p-1.5" : "px-2 py-1"
      }`}
    >
      <Icon size={18} />
      {!minimized && <span className="text-xs">{label}</span>}
    </div>
  );
};

export const TicketTag = ({ minimized = false }: TagProps) => {
  return (
    <BaseTag
      icon={Ticket}
      label="Billetterie"
      backgroundColor={TAG_COLORS.TICKET.backgroundColor}
      textColor={TAG_COLORS.TICKET.textColor}
      minimized={minimized}
    />
  );
};

export const CampingTag = ({ minimized = false }: TagProps) => {
  return (
    <BaseTag
      icon={Tent}
      label="Camping"
      backgroundColor={TAG_COLORS.CAMPING.backgroundColor}
      textColor={TAG_COLORS.CAMPING.textColor}
      minimized={minimized}
    />
  );
};

export const GiftTag = ({ minimized = false }: TagProps) => {
  return (
    <BaseTag
      icon={Gift}
      label="Cadeau"
      backgroundColor={TAG_COLORS.GIFT.backgroundColor}
      textColor={TAG_COLORS.GIFT.textColor}
      minimized={minimized}
    />
  );
};

export const CinemaTag = ({ minimized = false }: TagProps) => {
  return (
    <BaseTag
      icon={Film}
      label="Cinéma"
      backgroundColor={TAG_COLORS.CINEMA.backgroundColor}
      textColor={TAG_COLORS.CINEMA.textColor}
      minimized={minimized}
    />
  );
};

export const ParkTag = ({ minimized = false }: TagProps) => {
  return (
    <BaseTag
      icon={RollerCoaster}
      label="Parc"
      backgroundColor={TAG_COLORS.PARK.backgroundColor}
      textColor={TAG_COLORS.PARK.textColor}
      minimized={minimized}
    />
  );
};

export const PartnerTag = ({ minimized = false }: TagProps) => {
  return (
    <BaseTag
      icon={Handshake}
      label="Partenaire"
      backgroundColor={TAG_COLORS.PARTNER.backgroundColor}
      textColor={TAG_COLORS.PARTNER.textColor}
      minimized={minimized}
    />
  );
};

export const DiscountTag = ({
  discount,
  minimized = false,
}: DiscountTagProps) => {
  return (
    <BaseTag
      icon={BadgePercent}
      label={`Remise ${discount}%`}
      backgroundColor={TAG_COLORS.DISCOUNT.backgroundColor}
      textColor={TAG_COLORS.DISCOUNT.textColor}
      minimized={minimized}
    />
  );
};
